"use strict";

exports.__esModule = true;
exports.CommentTableElement = void 0;
var _isEmpty2 = _interopRequireDefault(require("ramda/src/isEmpty"));
var _react = _interopRequireWildcard(require("react"));
var _history = require("history");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _Core = require("../../Core");
var _DataTable = require("../../Core/DataTable/DataTable");
var _formatColumns = require("../../Core/DataTable/formatColumns");
var _Device = require("../../Device");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _Time = require("../../Time");
var _User = require("../../User");
var _CommentTableDataProvider = require("./CommentTableDataProvider");
var _helpers = require("./helpers");
var _defaultCommentTableWidgetColumns = require("./defaultCommentTableWidgetColumns");
var _comments = require("../DataTable/DataSources/comments");
var _PlantStateActivities = require("../../PlantStateActivities");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CommentTableElement = exports.CommentTableElement = (0, _reactRouterCompat.withRouter)(function (props) {
  var pageSizeList = [25, 100, 500, 1000];
  var width = props.width,
    height = props.height,
    dataRange = props.dataRange,
    configuration = props.configuration,
    dataItemName = props.dataItemName,
    pageSizes = props.pageSizes,
    fetchDataOnlyOnSelection = props.fetchDataOnlyOnSelection;
  var children = props.children;
  var dataSource = "Comments";
  var defaultPageSize = (0, _helpers.nearestIndexInPageSizeList)(pageSizes || pageSizeList, (0, _helpers.getDefaultPageSize)(configuration, height) < 0 ? 0 : (0, _helpers.getDefaultPageSize)(configuration, height));
  var _useState = (0, _react.useState)({
      page: 0,
      pageSize: defaultPageSize
    }),
    pagination = _useState[0],
    setPagination = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    data = _useState2[0],
    setData = _useState2[1];
  var translator = _react["default"].useContext(_Core.TranslatorContext);
  var time = _react["default"].useContext(_Time.TimeContext);
  var devices = _react["default"].useContext(_Device.AllDeviceListContext);
  var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(_react["default"].useContext(_PlantStateActivitiesContext.PlantStateActivitiesContext));
  var users = _react["default"].useContext(_User.UserListContext);
  var selection = _react["default"].useContext(_Core.SelectionContext);
  var translate = translator.translate;
  var commentDefinition = (0, _comments.commentsDefinition)(translate);
  if ((0, _isEmpty2["default"])(children)) {
    children = _defaultCommentTableWidgetColumns.defaultCommentTableWidgetColumns;
  }

  // Columns are configured on child elements but rendered by the table so gather up the configs
  var columnsConfig = children.map(function (child) {
    return child.props;
  });
  var defaultSorted = (0, _helpers.getDefaultSortOrder)(columnsConfig);
  var defaultFilters = (0, _helpers.getDefaultFilters)(columnsConfig, {
    devices: devices,
    plantStateActivities: plantStateActivities
  });
  if (selection.isSelectionEmpty(dataRange, fetchDataOnlyOnSelection)) {
    var _data = [];
    var rowFormatters = commentDefinition.rowFormatters;
    var columns = (0, _formatColumns.formatColumns)(columnsConfig, _data, {
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      users: users
    }, false);
    return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, {
      columns: columns,
      data: _data,
      height: height,
      width: width,
      defaultSorted: defaultSorted.map(function (_ref) {
        var id = _ref.id,
          desc = _ref.desc;
        return {
          id: id,
          desc: desc
        };
      }),
      defaultFiltered: defaultFilters,
      defaultPageSize: defaultPageSize,
      rowFormatters: rowFormatters,
      pageSizeOptions: pageSizes || pageSizeList,
      noDataText: "Make selection to view data"
    });
  }
  var updatePagination = function updatePagination(updatedPagination) {
    if (!(0, _reactFastCompare["default"])(pagination, updatedPagination)) {
      setPagination(updatedPagination);
    }
  };
  var handleDataChange = function handleDataChange(updatedData) {
    if (updatedData === void 0) {
      updatedData = [];
    }
    setData(updatedData.map(commentDefinition.parseData));
    updatePagination(Object.assign({}, pagination, {
      size: pagination.pageSize,
      number: pagination.page
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_CommentTableDataProvider.CommentTableDataProvider, {
    width: width,
    height: height,
    dataRange: dataRange,
    fetchDataOnlyOnSelection: fetchDataOnlyOnSelection,
    eventSource: dataSource,
    pagination: pagination,
    dataItemName: dataItemName,
    onData: handleDataChange,
    columns: columnsConfig
  }, function (_ref2) {
    var fetching = _ref2.fetching,
      reload = _ref2.reload,
      error = _ref2.error;
    if (error) {
      return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
        error: error
      });
    }
    var rowFormatters = commentDefinition.rowFormatters;
    var columns = (0, _formatColumns.formatColumns)(columnsConfig, data, {
      translate: translate,
      time: time,
      devices: devices,
      plantStateActivities: plantStateActivities,
      users: users
    });
    return /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, {
      loading: fetching,
      manual: true,
      applyPagination: function applyPagination(updatedData) {
        return updatedData.slice(pagination.page * pagination.pageSize, (pagination.page + 1) * pagination.pageSize);
      },
      showPagination: true,
      pages: Math.ceil(data.length / pagination.pageSize),
      page: pagination.page,
      pageSize: pagination.pageSize,
      onFetchData: function onFetchData(_ref3) {
        var page = _ref3.page,
          pageSize = _ref3.pageSize;
        setPagination({
          page: page,
          pageSize: pageSize
        });
      },
      defaultSorted: defaultSorted.map(function (_ref4) {
        var id = _ref4.id,
          desc = _ref4.desc;
        return {
          id: id,
          desc: desc
        };
      }),
      defaultFiltered: defaultFilters,
      getDataForCSV: undefined,
      columns: columns,
      data: data,
      height: height,
      width: width,
      defaultPageSize: defaultPageSize,
      rowFormatters: rowFormatters,
      reload: reload,
      style: {
        height: height + "px",
        width: width + "px"
      }
    });
  });
});